import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "glores-B-join-agree" }
const _hoisted_5 = { class: "glores-B-all-agree" }
const _hoisted_6 = { class: "privacyBody" }
const _hoisted_7 = { class: "pcon" }
const _hoisted_8 = { class: "sc_ptop" }
const _hoisted_9 = { class: "pcon" }
const _hoisted_10 = { class: "sc_ptop" }
const _hoisted_11 = { class: "pcon" }
const _hoisted_12 = { class: "sc_ptop" }
const _hoisted_13 = { class: "pcon" }
const _hoisted_14 = { class: "sc_ptop" }
const _hoisted_15 = { class: "pcon" }
const _hoisted_16 = { class: "sc_ptop" }
const _hoisted_17 = { class: "pcon" }
const _hoisted_18 = { class: "sc_ptop" }
const _hoisted_19 = { class: "pcon" }
const _hoisted_20 = { class: "sc_ptop" }
const _hoisted_21 = { class: "pcon" }
const _hoisted_22 = { class: "sc_ptop" }
const _hoisted_23 = { class: "pcon" }
const _hoisted_24 = { class: "sc_ptop" }
const _hoisted_25 = { class: "pcon" }
const _hoisted_26 = { class: "sc_ptop" }
const _hoisted_27 = { class: "pcon" }
const _hoisted_28 = { class: "sc_ptop" }
const _hoisted_29 = { class: "pcon" }
const _hoisted_30 = { class: "sc_ptop" }
const _hoisted_31 = { class: "pcon" }
const _hoisted_32 = { class: "sc_ptop" }
const _hoisted_33 = { class: "pcon" }
const _hoisted_34 = { class: "sc_ptop" }
const _hoisted_35 = { class: "pcon" }
const _hoisted_36 = { class: "sc_ptop" }
const _hoisted_37 = { class: "consult_info" }
const _hoisted_38 = { class: "sc_ptop" }
const _hoisted_39 = { class: "glores-B-agree-check" }
const _hoisted_40 = { class: "glores-B-agree-check" }
const _hoisted_41 = { class: "glores-B-btn-wrap glores-B-m-half glores-B-mgt-type1" }
const _hoisted_42 = { class: "btn-cell" }
const _hoisted_43 = { class: "btn-cell" }

import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Join',
  setup(__props) {

const useAlert = useAlertDialog();

const router = useRouter();

// 개별 약관 동의 상태를 위한 ref
const termsAgreed = ref(false);
const privacyAgreed = ref(false);

// 이용약관 스크롤 박스 ref
const termsAgreementBox = ref<HTMLElement | null>(null);

// '전체 동의' 체크박스를 위한 computed 속성
const allAgreed = computed({
  // 모든 필수 약관이 동의되었는지 확인
  get: () => termsAgreed.value && privacyAgreed.value,
  // '전체 동의' 체크박스 상태 변경 시 모든 개별 약관 상태 업데이트
  set: (val) => {
    termsAgreed.value = val;
    privacyAgreed.value = val;
  },
});

function goBack() {
  router.back();
}

async function join() {
  if (allAgreed.value) {
    // 모든 필수 약관에 동의했는지 확인
    router.push(`${USER_ROUTES.Join.Registration.Path}`);
  } else {
    await useAlert("이용약관과 개인정보 처리방침에 모두 동의해주세요.");
  }
}

// 이용약관 박스 상단으로 스크롤하는 함수
function scrollToTermsTop() {
  if (termsAgreementBox.value) {
    termsAgreementBox.value.scrollTop = 0;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "",
      subtitle: "",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[53] || (_cache[53] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("약관동의"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "glores-B-join-step" }, [
            _createElementVNode("ol", null, [
              _createElementVNode("li", { class: "on" }, [
                _createElementVNode("span", null, "01 약관동의")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "02 정보입력")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "03 가입완료")
              ])
            ])
          ], -1)),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "glores-B-join-title" }, [
            _createElementVNode("h3", { class: "join-title" }, "약관동의")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "all_agree_chk",
              name: "all_agree_chk",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allAgreed).value = $event))
            }, null, 512), [
              [_vModelCheckbox, allAgreed.value]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("label", { for: "all_agree_chk" }, "전체 동의합니다.", -1))
          ]),
          _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "glores-B-agree-title mgt-none" }, [
            _createElementVNode("span", null, "이용약관"),
            _createTextVNode(),
            _createElementVNode("strong", { class: "point-color1" }, "[필수]")
          ], -1)),
          _createElementVNode("div", {
            class: "glores-B-agree-box",
            ref_key: "termsAgreementBox",
            ref: termsAgreementBox
          }, [
            _cache[46] || (_cache[46] = _createElementVNode("link", {
              rel: "stylesheet",
              type: "text/css",
              href: "img_up/_addon/_styles/agree/privacy.css",
              media: "all"
            }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[32] || (_cache[32] = _createElementVNode("a", { name: "top" }, null, -1)),
              _cache[33] || (_cache[33] = _createElementVNode("h3", null, "이용약관", -1)),
              _cache[34] || (_cache[34] = _createElementVNode("h4", null, "제 1장 총 칙", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("h4", null, "제 1 조 (목적)", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, " 이 약관은 COKOLab. Inc. (이하 \"사이트\"라 합니다)에서 제공하는 인터넷서비스(이하 \"서비스\"라 합니다)의 이용 조건 및 절차에 관한 기본적인 사항을 규정함을 목적으로 합니다. ", -1)),
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", null, "제 2 조 (약관의 효력 및 변경)", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 이 약관은 서비스 화면이나 기타의 방법으로 이용고객에게 공지함으로써 효력을 발생합니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 사이트는 이 약관의 내용을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 공지 또는 통지함으로써 효력을 발생합니다. "),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", null, "제 3 조 (용어의 정의)", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                  _createTextVNode(" 이 약관에서 사용하는 용어의 정의는 다음과 같습니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ① 회원 : 사이트와 서비스 이용계약을 체결하거나 이용자 아이디(ID)를 부여받은 개인 또는 단체를 말합니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 신청자 : 회원가입을 신청하는 개인 또는 단체를 말합니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ③ 아이디(ID) : 회원의 식별과 서비스 이용을 위하여 회원이 정하고 사이트가 승인하는 문자와 숫자의 조합을 말합니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ④ 비밀번호 : 회원이 부여 받은 아이디(ID)와 일치된 회원임을 확인하고, 회원 자신의 비밀을 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 말합니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ⑤ 해지 : 사이트 또는 회원이 서비스 이용계약을 취소하는 것을 말합니다. "),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _cache[36] || (_cache[36] = _createElementVNode("h4", null, "제 2 장 서비스 이용계약", -1)),
              _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[10] || (_cache[10] = _createElementVNode("h4", null, "제 4 조 (이용계약의 성립)", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 이용약관 하단의 동의 버튼을 누르면 이 약관에 동의하는 것으로 간주됩니다. "),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 이용계약은 서비스 이용희망자의 이용약관 동의 후 이용 신청에 대하여 사이트가 승낙함으로써 성립합니다. "),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_14, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[12] || (_cache[12] = _createElementVNode("h4", null, "제 5 조 (이용신청)", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 신청자가 본 서비스를 이용하기 위해서는 사이트 소정의 가입신청 양식에서 요구하는 이용자 정보를 기록하여 제출해야 합니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 가입신청 양식에 기재하는 모든 이용자 정보는 모두 실제 데이터인 것으로 간주됩니다. 실명이나 실제 정보를 입력하지 않은 사용자는 법적인 보호를 받을 수 없으며, 서비스의 제한을 받을 수 있습니다. "),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_16, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[14] || (_cache[14] = _createStaticVNode("<h4>제 6 조 (이용신청의 승낙)</h4><p> ① 사이트는 신청자에 대하여 제2항, 제3항의 경우를 예외로 하여 서비스 이용신청을 승낙합니다. <br> ② 사이트는 다음에 해당하는 경우에 그 신청에 대한 승낙 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다.<br> 가. 서비스 관련 설비에 여유가 없는 경우<br> 나. 기술상 지장이 있는 경우 <br> 다. 기타 사이트가 필요하다고 인정되는 경우 <br> ③ 사이트는 신청자가 다음에 해당하는 경우에는 승낙을 거부할 수 있습니다. <br> 가. 다른 개인(사이트)의 명의를 사용하여 신청한 경우<br> 나. 이용자 정보를 허위로 기재하여 신청한 경우<br> 다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br> 라. 기타 사이트 소정의 이용신청요건을 충족하지 못하는 경우<br></p>", 2)),
                _createElementVNode("p", _hoisted_18, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[15] || (_cache[15] = _createElementVNode("h4", null, "제 7 조 (이용자정보의 변경)", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("p", null, [
                  _createTextVNode(" 회원은 이용 신청시에 기재했던 회원정보가 변경되었을 경우에는, 온라인으로 수정하여야 하며 변경하지 않음으로 인하여 발생되는 모든 문제의 책임은 회원에게 있습니다. "),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_20, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("h4", null, "제 3 장 계약 당사자의 의무", -1)),
              _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_21, [
                _cache[17] || (_cache[17] = _createStaticVNode("<h4>제 8 조 (사이트의 의무)</h4><p> ① 사이트는 회원에게 각 호의 서비스를 제공합니다.<br> 가. 신규서비스와 도메인 정보에 대한 뉴스레터 발송 <br> 나. 추가 도메인 등록시 개인정보 자동 입력 <br> 다. 도메인 등록, 관리를 위한 각종 부가서비스<br> ② 사이트는 서비스 제공과 관련하여 취득한 회원의 개인정보를 회원의 동의없이 타인에게 누설, 공개 또는 배포할 수 없으며, 서비스관련 업무 이외의 상업적 목적으로 사용할 수 없습니다. 단, 다음 각 호의 1에 해당하는 경우는 예외입니다. <br> 가. 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우<br> 나. 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우<br> 다. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우<br> ③ 사이트는 이 약관에서 정한 바에 따라 지속적, 안정적으로 서비스를 제공할 의무가 있습니다.<br></p>", 2)),
                _createElementVNode("p", _hoisted_22, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[18] || (_cache[18] = _createStaticVNode("<h4>제 9 조 (회원의 의무)</h4><p> ① 회원은 서비스 이용 시 다음 각 호의 행위를 하지 않아야 합니다. <br> 가. 다른 회원의 ID를 부정하게 사용하는 행위<br> 나. 서비스에서 얻은 정보를 사이트의 사전승낙 없이 회원의 이용 이외의 목적으로 복제하거나 이를 변경, 출판 및 방송 등에 사용하거나 타인에게 제공하는 행위<br> 다. 사이트의 저작권, 타인의 저작권 등 기타 권리를 침해하는 행위<br> 라. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위<br> 마. 범죄와 결부된다고 객관적으로 판단되는 행위<br> 바. 기타 관계법령에 위배되는 행위<br> ② 회원은 관계법령, 이 약관에서 규정하는 사항, 서비스 이용 안내 및 주의 사항을 준수하여야 합니다.<br> ③ 회원은 내용별로 사이트가 서비스 공지사항에 게시하거나 별도로 공지한 이용 제한 사항을 준수하여야 합니다.<br></p>", 2)),
                _createElementVNode("p", _hoisted_24, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _cache[40] || (_cache[40] = _createElementVNode("h4", null, "제 4 장 서비스 제공 및 이용", -1)),
              _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_25, [
                _cache[19] || (_cache[19] = _createElementVNode("h4", null, " 제 10 조 (회원 아이디(ID)와 비밀번호 관리에 대한 회원의 의무) ", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 아이디(ID)와 비밀번호에 대한 모든 관리는 회원에게 책임이 있습니다. 회원에게 부여된 아이디(ID)와 비밀번호의 관리소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 전적인 책임은 회원에게 있습니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 자신의 아이디(ID)가 부정하게 사용된 경우 또는 기타 보안 위반에 대하여, 회원은 반드시 사이트에 그 사실을 통보해야 합니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_26, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[21] || (_cache[21] = _createElementVNode("h4", null, "제 11 조 (서비스 제한 및 정지)", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 사이트는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신 사업자가 전기통신서비스를 중지하는 등 기타 불가항력적 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 사이트는 제1항의 규정에 의하여 서비스의 이용을 제한하거나 정지할 때에는 그 사유 및 제한기간 등을 지체없이 회원에게 알려야 합니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_28, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("h4", null, "제5장 계약사항의 변경, 해지", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_29, [
                _cache[23] || (_cache[23] = _createElementVNode("h4", null, "제 12 조 (정보의 변경)", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("p", null, [
                  _createTextVNode(" 회원이 주소, 비밀번호 등 고객정보를 변경하고자 하는 경우에는 홈페이지의 회원정보 변경 서비스를 이용하여 변경할 수 있습니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_30, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[25] || (_cache[25] = _createElementVNode("h4", null, "제 13 조 (계약사항의 해지)", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("p", null, [
                  _createTextVNode(" 회원은 서비스 이용계약을 해지할 수 있으며, 해지할 경우에는 본인이 직접 서비스를 통하거나 전화 또는 온라인 등으로 사이트에 해지신청을 하여야 합니다. 사이트는 해지신청이 접수된 당일부터 해당 회원의 서비스 이용을 제한합니다. 사이트는 회원이 다음 각 항의 1에 해당하여 이용계약을 해지하고자 할 경우에는 해지조치 7일전까지 그 뜻을 이용고객에게 통지하여 소명할 기회를 주어야 합니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ① 이용고객이 이용제한 규정을 위반하거나 그 이용제한 기간 내에 제한 사유를 해소하지 않는 경우"),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 정보통신윤리위원회가 이용해지를 요구한 경우"),
                  _createElementVNode("br"),
                  _createTextVNode(" ③ 이용고객이 정당한 사유 없이 의견진술에 응하지 아니한 경우"),
                  _createElementVNode("br"),
                  _createTextVNode(" ④ 타인 명의로 신청을 하였거나 신청서 내용의 허위 기재 또는 허위서류를 첨부하여 이용계약을 체결한 경우"),
                  _createElementVNode("br"),
                  _createTextVNode(" 사이트는 상기 규정에 의하여 해지된 이용고객에 대해서는 별도로 정한 기간동안 가입을 제한할 수 있습니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_32, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _cache[44] || (_cache[44] = _createElementVNode("h4", null, "제6장 손해배상", -1)),
              _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_33, [
                _cache[27] || (_cache[27] = _createElementVNode("h4", null, "제 14 조 (면책조항)", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("p", null, [
                  _createTextVNode(" ① 사이트는 회원이 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서는 책임이 면제됩니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ② 사이트는 회원의 귀책사유나 제3자의 고의로 인하여 서비스에 장애가 발생하거나 회원의 데이터가 훼손된 경우에 책임이 면제됩니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ③ 사이트는 회원이 게시 또는 전송한 자료의 내용에 대해서는 책임이 면제됩니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" ④ 상표권이 있는 도메인의 경우, 이로 인해 발생할 수도 있는 손해나 배상에 대한 책임은 구매한 회원 당사자에게 있으며, 사이트는 이에 대한 일체의 책임을 지지 않습니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_34, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[29] || (_cache[29] = _createElementVNode("h4", null, "제 15 조 (관할법원))", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("p", null, [
                  _createTextVNode(" 서비스와 관련하여 사이트와 회원간에 분쟁이 발생할 경우 사이트의 본사 소재지를 관할하는 법원을 관할법원으로 합니다."),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("p", _hoisted_36, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[31] || (_cache[31] = _createElementVNode("p", null, "(시행일) 이 약관은 2015년 11월부터 시행합니다.", -1)),
                _createElementVNode("p", _hoisted_38, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(scrollToTermsTop, ["prevent"])
                  }, "TOP")
                ])
              ])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_39, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "agree_checkbox",
              id: "agree_checkbox1",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((termsAgreed).value = $event))
            }, null, 512), [
              [_vModelCheckbox, termsAgreed.value]
            ]),
            _cache[47] || (_cache[47] = _createElementVNode("label", { for: "agree_checkbox1" }, "이용약관에 동의합니다.", -1))
          ]),
          _cache[52] || (_cache[52] = _createStaticVNode("<h4 class=\"glores-B-agree-title\"><span>개인정보 처리방침</span><strong class=\"point-color1\">[필수]</strong></h4><div class=\"glores-B-agree-box\"><h5 class=\"mgt-none\">수집하는 개인정보의 항목</h5><p> 회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. </p><ul><li><strong>- 수집항목</strong> : <span class=\"privacy_column_list\"></span></li><li><strong>- 개인정보 수집방법</strong> : <span>홈페이지</span>(<span>회원가입</span>) </li></ul><h5>개인정보의 수집 및 이용목적</h5><p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p><ul><li><strong>- 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</strong><p>구매 및 요금 결제, 물품배송 또는 청구지 등 발송</p></li><li><strong>- 회원 관리</strong><p> 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인 </p></li></ul><h5>개인정보의 보유 및 이용기간</h5><p> 회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다. </p></div>", 2)),
          _createElementVNode("div", _hoisted_40, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "agree_checkbox",
              id: "agree_checkbox2",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((privacyAgreed).value = $event))
            }, null, 512), [
              [_vModelCheckbox, privacyAgreed.value]
            ]),
            _cache[48] || (_cache[48] = _createElementVNode("label", { for: "agree_checkbox2" }, "개인정보처리방침에 동의합니다.", -1))
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("a", {
                onClick: _withModifiers(goBack, ["prevent"]),
                class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width"
              }, "이전")
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("a", {
                onClick: _withModifiers(join, ["prevent"]),
                class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width glores-B-highlight"
              }, "회원가입")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})